import IAtomModel from "./IAtomModel";
import IBondModel from "./IBondModel";

export default class BondModel implements IBondModel{
  a1: IAtomModel;
  a2: IAtomModel;
  order: number;
  type?: string;
  isomerConfig?: 'e' | 'z';
  isInRing : boolean = false;
  isAromatic : boolean = false;
  isAliphatic : boolean = false;
  id?: string;

  constructor(atom1: IAtomModel, atom2: IAtomModel, order: number = 1, type?: string) {
    this.a1 =  atom1;
    this.a2 =  atom2;
    this.order = order;
    this.type = type;
  }

  isAttachedTo(atom: IAtomModel) {
    return atom === this.a1 || atom === this.a2;
  }

  reverseBond() {
    const t = this.a1;
    this.a1 = this.a2;
    this.a2 = t;

    this.flipChirality();
  }

  flipChirality() {
    if (this.type) {
      if (this.type === "\\") {
        this.type = "/"
      } else if (this.type === "/") {
        this.type = "\\";
      }

      else if (this.type === "w") {
        this.type = "d"
      } else if (this.type === "d") {
        this.type = "w";
      }
    }
  }

  makeBondUniform(atoms : IAtomModel[]) {
    if (atoms.indexOf(this.a1) > atoms.indexOf(this.a2)) {
      this.reverseBond();
    }
  }

  getOtherAtom(a: IAtomModel): IAtomModel {
    return a === this.a1 ? this.a2 : this.a1;
  }

  copy(a1?:IAtomModel, a2?:IAtomModel): IBondModel {
    return {
      a1: a1 || this.a1,
      a2: a2 || this.a2,
      copy: this.copy,
      flipChirality: this.flipChirality,
      getOtherAtom: this.getOtherAtom,
      isAliphatic: this.isAliphatic,
      isAromatic: this.isAromatic,
      isAttachedTo: this.isAttachedTo,
      order: this.order,
      reverseBond: this.reverseBond,
      type: this.type,
      isomerConfig: this.isomerConfig,
      id: this.id
    }
  }
}
